export default __webpack_public_path__ + "static/media/88.b0e9b15c.jpg";